"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("../../../theme/makeStyles");
exports.default = (0, makeStyles_1.makeStyles)(function (theme) { return ({
    root: function (_a) {
        var variant = _a.variant;
        return ({
            display: 'flex',
            padding: '16px',
            cursor: 'pointer',
            border: "1px solid ".concat(theme.colors.gray200),
            borderRadius: '4px',
            backgroundColor: "".concat({
                warning: theme.colors.warningBackground,
                danger: theme.colors.dangerActive
            }[variant]),
            '& p': {
                margin: 0
            }
        });
    },
    icon: {
        padding: '2px 0'
    },
    body: {
        margin: '0 16px',
        width: '100%'
    },
    title: function (_a) {
        var variant = _a.variant;
        return ({
            color: "".concat(variant === 'danger' ? theme.colors.white : theme.colors.gray500),
            size: '16px',
            lineHeight: '28px',
            fontWeight: 800,
            fontFamily: "'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif"
        });
    },
    description: function (_a) {
        var variant = _a.variant;
        return ({
            color: "".concat(variant === 'danger' ? theme.colors.white : theme.colors.gray500),
            size: '16px',
            lineHeight: '28px',
            fontWeight: 400,
            fontFamily: "'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif",
            '&.closed': {
                display: 'none'
            }
        });
    }
}); });
